import * as React from "react";

import { Theme } from "@radix-ui/themes";

import { radixConfig } from "../styles";

interface ThemeDecoratorsProps
  extends React.ComponentPropsWithoutRef<typeof Theme> {}

const ThemeDecorators = React.forwardRef<
  React.ElementRef<typeof Theme>,
  ThemeDecoratorsProps
>((props, ref) => {
  return <Theme {...radixConfig} {...props} ref={ref} />;
});
ThemeDecorators.displayName = "ThemeDecorators";

export { ThemeDecorators };
